import { createAlertsManager } from '@bigcommerce/big-design'

import { IAlertMessage } from '@/types/stores'

export const d5AlertsManager: any = createAlertsManager()

export const D5Message = {
  success: (msg: string) => {
    const alertMessage: IAlertMessage = {
      header: 'Success',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'success',
      onClose: () => null,
      autoDismiss: true,
    }
    d5AlertsManager.add(alertMessage)
  },
  error: (msg: string) => {
    const alertMessage: IAlertMessage = {
      header: 'Failed',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'error',
      onClose: () => null,
      autoDismiss: true,
    }
    d5AlertsManager.add(alertMessage)
  },
  warning: (msg: string) => {
    const alertMessage: IAlertMessage = {
      header: 'Warning',
      messages: [
        {
          text: msg,
        },
      ],
      type: 'warning',
      onClose: () => null,
      autoDismiss: true,
    }
    d5AlertsManager.add(alertMessage)
  },
}
